import { GD } from './GD';
import { STORE_NAME } from './STORE';
import { User } from './User';
/**
 * Supports read/write localStorage - write works only for cookie consent allowed names (see gd.cookieConsent.names)
 * TODO: refactor too much read and write when creating a instance. The problem on lazy loading/saving the data is
 * too support multiple instances of this Storage object.
 */
var Storage = /** @class */ (function () {
    /**
     * Initialize defaults
     */
    function Storage() {
        this.defaults = {};
        this.defaults.gd = new GD();
        this.defaults.user = new User();
    }
    /**
     * Returns a object from localStorage (already JSON parsed).
     *
     * Will handle default values for GD and User.
     * @param store
     */
    Storage.prototype.read = function (store) {
        var _this = this;
        var data = localStorage.getItem(store);
        var dataObj = JSON.parse(data || '{}');
        if (this.defaults[store]) {
            Object.keys(this.defaults[store]).forEach(function (key) {
                if (dataObj[key] === undefined) {
                    dataObj[key] = _this.defaults[store][key];
                }
            });
        }
        return dataObj;
    };
    /**
     * writes data to locale storage. Only cookies which are accepted in cookieConsent will be saved
     * @param store
     * @param data
     */
    Storage.prototype.write = function (store, data) {
        // would be great to cache this but if we create multiple instance from Storage it will not work ;)
        var gd = this.read(STORE_NAME.GD);
        if (gd.cookieConsent.names.indexOf(store) === -1) {
            // skip write if cookie names are not part of the cookie consent
            console.warn('block save settings by user - you need to activate cookie saving ( see cookie consent agreement )');
            return;
        }
        var custom = Object.assign({}, this.read(store) || {}, data);
        localStorage.setItem(store, JSON.stringify(custom));
    };
    return Storage;
}());
export default Storage;
//# sourceMappingURL=Storage.js.map